import { authClient } from "@/shared/lib/axios";
import {
	type DeleteRecordResponse,
	DeleteRecordResponseSchema,
	type ReadRecordResponse,
	ReadRecordRequestSchema,
	ReadRecordResponseSchema,
	type UpdateRecordRequest,
	type UpdateRecordResponse,
	UpdateRecordRequestSchema,
	UpdateRecordResponseSchema,
	type UpdateWorkflowDbSchemaRequest,
	UpdateWorkflowDbSchemaRequestSchema,
	type UpdateWorkflowDbSchemaResponse,
	UpdateWorkflowDbSchemaResponseSchema,
	type WorkflowDbDataResponse,
	WorkflowDbDataResponseSchema,
	type WorkflowDbSchemaResponse,
	WorkflowDbSchemaResponseSchema,
	type WriteRecordResponse,
	WriteRecordResponseSchema,
} from "./workflow-db.types";

const endpoint = (workflowId: string) => `/workflows/${workflowId}/db`;

export const workflowDbApi = {
	getData: async (workflowId: string): Promise<WorkflowDbDataResponse> => {
		const { data } = await authClient.get(endpoint(workflowId));
		return WorkflowDbDataResponseSchema.parse(data);
	},

	getSchema: async (workflowId: string): Promise<WorkflowDbSchemaResponse> => {
		const { data } = await authClient.get(`${endpoint(workflowId)}/schema`);
		return WorkflowDbSchemaResponseSchema.parse(data);
	},

	updateSchema: async (
		workflowId: string,
		request: UpdateWorkflowDbSchemaRequest,
	): Promise<UpdateWorkflowDbSchemaResponse> => {
		const payload = UpdateWorkflowDbSchemaRequestSchema.parse(request);
		const { data } = await authClient.put(`${endpoint(workflowId)}/schema`, payload);
		return UpdateWorkflowDbSchemaResponseSchema.parse(data);
	},

	writeRecord: async (
		workflowId: string,
		table: string,
		recordData: Record<string, unknown>,
	): Promise<WriteRecordResponse> => {
		const { data } = await authClient.post(`${endpoint(workflowId)}/write`, {
			table,
			data: recordData,
		});
		return WriteRecordResponseSchema.parse(data);
	},

	deleteRecord: async (
		workflowId: string,
		table: string,
		ref: string,
	): Promise<DeleteRecordResponse> => {
		const { data } = await authClient.post(`${endpoint(workflowId)}/delete`, {
			table,
			ref,
		});
		return DeleteRecordResponseSchema.parse(data);
	},

	updateRecord: async (
		workflowId: string,
		request: UpdateRecordRequest,
	): Promise<UpdateRecordResponse> => {
		const payload = UpdateRecordRequestSchema.parse(request);
		const { data } = await authClient.post(`${endpoint(workflowId)}/update`, payload);
		return UpdateRecordResponseSchema.parse(data);
	},

	readRecord: async (
		workflowId: string,
		ref: string,
		select?: string[],
	): Promise<ReadRecordResponse> => {
		const payload = ReadRecordRequestSchema.parse({ ref, select });
		const { data } = await authClient.post(`${endpoint(workflowId)}/read`, payload);
		return ReadRecordResponseSchema.parse(data);
	},
};
